import React from "react";
import { Link } from "react-router-dom";
import { i18n as i } from "@/i18n";
import Exception from "../../components/Exception";

function NoPermission(props: any) {
  return (
    <Exception
      type="403"
      desc={i("抱歉，你无权访问该页面")}
      style={{ minHeight: 500, height: "80%" }}
      linkElement={Link}
      {...props}
    />
  );
}

export default NoPermission;
